(ns frontend.view.modals.session-timeout.events
  (:require [frontend.state.current-session :as session]))

(defn format-time-m-s [arg]
  (let [arg (or arg 0)
        s (-> arg (quot 1000) (mod 60))
        m (-> arg (quot 60000) (mod 60))
        h (-> arg (quot 3600000) (mod 24))]
    (str
      (when (pos? h)
        (str h "h "))
      (when (pos? m)
        (str m "m "))
      s "s")))

(defn track-time! [state]
  (let [expires-at (:expires-at @session/session)

        now (.getTime (js/Date.))
        expires-in (when expires-at
                     (- expires-at now))]
    (swap! state assoc :expires-in expires-in)
    expires-in))

(defn start-tracker! [state]
  (let [handle (js/setInterval (partial track-time! state) 1000)]
    (swap! state assoc :timer-handle handle)))

(defn stop-tracker! [state]
  (let [handle (:timer-handle @state)]
    (js/clearInterval handle)))
